import config from "../../../settings/config";

export async function fetchGetFirmwareFiles(token) {
    try {
        const response = await fetch(`${config.app.host}/api/v1/admin/getUploadFiles`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorMessage = `Ошибка ${response.status}: ${await response.text()}`;
            console.error(errorMessage);
            return null;
        }

        return await response.json();

    } catch (err) {
        console.error("Ошибка при запросе устройств:", err);
        return null;
    } finally {
    }
}

export async function deleteFile(fileName, token) {
    try {
        const response = await fetch(`${config.app.host}/api/v1/admin/deleteFirmware/${encodeURIComponent(fileName)}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorMessage = `Ошибка ${response.status}: ${await response.text()}`;
            console.error(errorMessage);
            throw new Error(errorMessage);
        }

        return await response.json();

    } catch (err) {
        console.error("Ошибка при удалении файла:", err);
        throw err;
    }
}

export async function downloadFile(fileName, token) {
    try {
        // Простой способ - открыть в новой вкладке
        const url = `${config.app.host}/api/v1/admin/downloadFirmware/${encodeURIComponent(fileName)}`;
        
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Ошибка ${response.status}: ${errorText}`);
        }

        // Получаем blob и создаем ссылку для скачивания
        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Освобождаем память
        setTimeout(() => URL.revokeObjectURL(downloadUrl), 100);
        
        return true;

    } catch (err) {
        console.error("Ошибка при скачивании файла:", err);
        return false;
    }
}





